import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProjectData } from './useProjectData';
import { useSendGpnAnalyticsEvent } from './useSendGpnAnalyticsEvent';

export const useHandleUploadContract = (projectId: string | undefined, methodology: string | undefined) => {
    const navigate = useNavigate();

    return useCallback(() => {
        navigate(`/projects/${methodology}/${projectId}/contract/upload`);
    }, [methodology, navigate, projectId]);
};

export const useHandleEditContract = (projectId: string | undefined, methodology: string | undefined) => {
    const navigate = useNavigate();

    return useCallback(() => {
        navigate(`/projects/${methodology}/${projectId}/contract/edit`);
    }, [methodology, navigate, projectId]);
};

export const useHandleUploadOrder = (projectId: string | undefined, methodology: string | undefined) => {
    const navigate = useNavigate();

    return useCallback(() => {
        navigate(`/projects/${methodology}/${projectId}/order/upload`);
    }, [methodology, navigate, projectId]);
};

export const useHandleCreateAgreements = (
    projectId: string | undefined,
    methodology: string | undefined,
    contractId: string | undefined,
) => {
    const navigate = useNavigate();

    const { projectData } = useProjectData(projectId, false);

    const { sendGpnAnalyticsEvent } = useSendGpnAnalyticsEvent();

    return useCallback(() => {
        sendGpnAnalyticsEvent({
            componentId: 'rim_create DS button_pressed',
            projectId,
            contractId: Number(contractId),
            projectName: projectData?.name,
            projectType: projectData?.contractType,
            projectDO: projectData?.subsidiary?.name,
            methodology: projectData?.methodology,
        });

        navigate(`/projects/${methodology}/${projectId}/contract/agreements`, { state: { createFromContract: true } });
    }, [
        contractId,
        methodology,
        navigate,
        projectData?.contractType,
        projectData?.methodology,
        projectData?.name,
        projectData?.subsidiary?.name,
        projectId,
        sendGpnAnalyticsEvent,
    ]);
};
